/** Yandex Navigator (ilova) va web xarita havolalari (SPEC §11). */
export const navigatorLinks = (lat: number, lng: number) => ({
  app: `yandexnavi://build_route_on_map?lat_to=${lat}&lon_to=${lng}`,
  web: `https://yandex.uz/maps/?rtext=~${lat},${lng}&rtt=auto`,
});
